import type { ReactNode } from 'react';
import { activeLanguage } from '../i18n/index.ts';
import { useAppConfig } from './turnstile.tsx';

/** Public docs article for keeping a company's existing business number. */
export const NUMBER_CUTOVER_DOC_SLUG = 'twilio-customer-number-cutover-checklist';

/**
 * A documentation article on the marketing site, in the language the app is
 * showing, or null when this deployment has no docs site. Same shape as the
 * ChatGPT guide link: `HELP_DOCS_URL` plus `/docs/<slug>`, with `/es` in front
 * of `/docs` for Spanish.
 */
export function helpDocUrl(docsUrl: string | null | undefined, slug: string): string | null {
  if (!docsUrl) return null;
  return `${docsUrl}${activeLanguage() === 'es' ? '/es' : ''}/docs/${slug}`;
}

/**
 * One docs-site link, opened in a new tab. Renders nothing when the deployment
 * has no docs site, so a settings card never offers a dead link.
 */
export function HelpDocLink({ slug, children }: { slug: string; children: ReactNode }) {
  const url = helpDocUrl(useAppConfig().data?.helpDocsUrl, slug);
  if (!url) return null;
  return (
    <>
      {' '}
      <a href={url} target="_blank" rel="noopener noreferrer" className="font-semibold hover:underline">
        {children}
      </a>
    </>
  );
}
